/**
 * מיון פריטי רשימת חוות דעת (דמו לקוח — לעתיד יוחלף ב־API).
 */
(function (global) {
  "use strict";

  function parseTs(el) {
    var v = parseInt(el.getAttribute("data-review-ts"), 10);
    return Number.isFinite(v) ? v : 0;
  }

  function parseRating(el) {
    var v = parseFloat(el.getAttribute("data-review-rating"));
    return Number.isFinite(v) ? v : 0;
  }

  /**
   * @param {HTMLElement} root — אלמנט .br-reviews
   * @param {string} mode — newest | oldest | highest | lowest
   */
  function sortItems(root, mode) {
    var list = root.querySelector("#reviews-list");
    if (!list) {
      return;
    }
    var items = Array.prototype.slice.call(list.querySelectorAll(".br-reviews__item"));
    items.sort(function (a, b) {
      if (mode === "newest") {
        return parseTs(b) - parseTs(a);
      }
      if (mode === "oldest") {
        return parseTs(a) - parseTs(b);
      }
      if (mode === "highest") {
        return parseRating(b) - parseRating(a);
      }
      if (mode === "lowest") {
        return parseRating(a) - parseRating(b);
      }
      return 0;
    });
    items.forEach(function (li) {
      list.appendChild(li);
    });
  }

  global.BusinessReviewsModule = global.BusinessReviewsModule || {};
  global.BusinessReviewsModule.sortItems = sortItems;
})(typeof window !== "undefined" ? window : this);
